import * as Models from "../ts/rlAdmin.models";
import * as Utils from "../ts/rlAdmin.utils";
import * as Consts from "../ts/rlAdmin.consts";
import * as moment from "moment";
import { EntityConfigService } from "../services/entity-config-service";
import { AccountService } from "../services/account-service";
import { LocalCacheService } from "../services/local-cache-service";
import { ListService } from "../services/list-service";
import { EntityService } from "../services/entity-service";
import { IParty } from "../ts/rlAdmin.models";


export function RLListTable(): ng.IDirective {
    return {
        restrict: 'E',
        bindToController: true,
        controller: RLListTableController,
        controllerAs: 'ltVM',
        scope: {
            charTypeID: '=charTypeId',
            entityDocuments: '=',
            initialized: '=?',
            customColumns: '=?',
            templateMetaData: '=?',
            visibility: '=',
            sortDir: '=?',
            sortField: '=?',
            page: '=',
            pageCount: '=',
            rowCount: '=',
            numFound: '=',
            selectable: '=?',
            selectedItems: '=?',
            selectedItemsArray: '=?',
            selectionRequired: '=?',
            openLinkInNewTab: '=?',
            onPageChanged: '&?',
            onPageSizeChanged: '&?',
            onSortChanged: '&?',
            allChecked: '=?',
            onDelete: '&?',
            onCopy: '&?',
            showPager: '@?',
            forceRefresh: '=?',
            lockedRows: '=?',
            allowedToDeleteRows: '=?',
            selectSingle: '=?',
            noShowTop: '=?'
        },
        transclude: {
            actions: '?actions'
        },
        template: require("/assets/app/templates/list-table.html"),
        link: ($scope: ng.IScope, $element: ng.IAugmentedJQuery, $attrs: ng.IAttributes, ctrl: any[], $transclude) => {
            $transclude(function (clone) {
                $scope['showTransclude'] = clone.length > 1;
            });
        }
    }
}

class RLListTableController {
    static $inject = ['$scope', 'entityConfigService', 'accountService', 'localCacheService', 'entityService', 'listService'];

    showPager: boolean;
    charTypeID: number;
    selectable: boolean;
    selectSingle: boolean;
    allChecked: boolean;
    page: number;
    pageCount: number;
    rowCount: number;
    numFound: number;
    forceRefresh: boolean = false;
    noShowTop: boolean;

    // not really a fan of this but sticking with the way it was already done in contact and catalog search controllers
    selectedItems: { [recIDTitle: string]: boolean } = {};
    selectedItemsArray: Array<Models.IEntitySearchDoc | Models.IUsageAmountDocument>;
    selectSingleItem: string;
    selectionRequired: boolean;

    initialized: boolean;
    visibility: number;

    availableColumns: Models.IListTableColumn[];

    customColumns: Models.ICustomUserColumns;

    associatedDeals: { [key: number]: string };
    associatedCatalogs: { [key: number]: string };
    associatedItems: Models.IAssociatedItem[];
    parties: Models.IParty[];


    selectedListID: string;
    charTypeUrl: string;

    entityDocuments: Models.IEntitySearchDoc[] | Models.IUsageAmountDocument[];
    rows: Models.IListTableRow[];
    openLinkInNewTab: boolean;

    onPageChanged: (event: { page: number }) => any;
    onPageSizeChanged: (event: { pageSize: number }) => any;
    onSortChanged: (event: { sortField: string, sortDir: number }) => any;
    lockedRows: _.Dictionary<boolean>;
    allowedToDeleteRows: _.Dictionary<boolean>;

    catalogHierarchy: Models.ICatalogHierarchy[];
    catalogHierarchyIDTitles: { [recTitle: string]: number } = {};
    catalogRecordHierarchy: { [recID: number]: Models.ICatalogHierarchy[] } = {};
    catalogRecTopMostParents: { [recID: number]: string[] } = {};
    catalogRecDirectParents: { [recID: number]: string[] } = {};
    catalogRecHierarchyPaths: { [recID: number]: string } = {};
    currentPreviewEntityID: string;
    rightsDealsDictionary: { [dealId: string]: { dealName: string, primaryContactId: number, primaryContactName: string } } = {};
    showTitleLink: boolean;
    moduleLevelCharTypeIDs: { [id: string]: number } = Consts.ModuleLevelCharTypes.IDs;

    associatedCatalogTitleIDDictionary: { [recTitle: string]: number } = {};
    associatedCatalogTitleDictionary: { [rowRecordId: number]: string[] } = {};
    associatedCatalogRecIDDictionary: { [rowRecordId: number]: number[] } = {};


    associatedDealTitleIDDictionary: { [recTitle: string]: number } = {};
    associatedDealTitleDictionary: { [rowRecordId: number]: string[] } = {};
    associatedDealRecIDDictionary: { [rowRecordId: number]: number[] } = {};

    constructor(
        $scope: ng.IScope,
        private entityConfigService: EntityConfigService,
        private accountService: AccountService,
        private cacheService: LocalCacheService,
        private entityService: EntityService,
        private listService: ListService) {
        this.catalogHierarchy = [];
        this.initialized = false;
        $scope.$watch(() => this.charTypeID, (newValue, oldValue) => {
            if (newValue) {
                this.charTypeUrl = Utils.UrlBuilder.getCharTypeSummaryUrl(this.charTypeID);
                this.getCharacteristicList(this.charTypeID);
                if (_.any(this.moduleLevelCharTypeIDs, (id) => id == this.charTypeID)) {
                    this.showTitleLink = true;
                }
                else {
                    this.showTitleLink = false;
                }
            }
        });

        $scope.$watch(() => this.forceRefresh, (newValue, oldValue) => {
            if (!oldValue && newValue) {
                //this.rows = ListUtil.GetRows(this.entityDocuments, this.customColumns.columns, this.availableColumns, this.lockedRows, this.allowedToDeleteRows);
                this.getRows();
                this.forceRefresh = false;
            }
        });

        $scope.$watchCollection(() => [this.entityDocuments, this.customColumns, this.availableColumns], (newValue, oldValue) => {
            if (this.customColumns && this.entityDocuments && this.availableColumns) {
                //this.rows = ListUtil.GetRows(this.entityDocuments, this.customColumns.columns, this.availableColumns, this.lockedRows, this.allowedToDeleteRows);
                this.getRows();
            }
        });

        $scope.$watch(() => this.entityDocuments, (newValue) => {
            if (this.entityDocuments && this.customColumns) {
                //this.rows = ListUtil.GetRows(this.entityDocuments, this.customColumns.columns, this.availableColumns, this.lockedRows, this.allowedToDeleteRows);
                //this.getRows();
            }
        }, true);

        // TODO: Fix the way selection works with this directive period
        // This is a 'temp' hack to work with entity-quick-search
        $scope.$watch(() => this.selectedItems, (newValue) => {
            this.syncSelectedItemsArrayFromLookup();  // should investigate consolidating into 1 list from 2 so we don't have to keep them in sync
        }, true);

        $scope.$watch(() => this.selectSingleItem, (newValue) => {
            this.syncSelectedItemsArrayFromLookup();  // should investigate consolidating into 1 list from 2 so we don't have to keep them in sync
        }, true);

        $scope.$watch(() => this.selectedItemsArray, (newValue, oldValue) => {
            if (this.selectSingle) {
                this.selectSingleItem = this.selectedItemsArray.length > 0 ? this.formatLookupKey(this.selectedItemsArray[0]) : "";
            }
            this.syncSelectedItemsLookupFromArray();
        }, true);

        $scope.$on(Consts.Events.RefreshViewEntity, (e, data) => {
            if (!_.isEmpty(data)) {
                this.currentPreviewEntityID = data;
            }
        });
    }

    $onInit() {
        this.selectedItemsArray = [];
    }

    private formatLookupKey(item: Models.IEntitySearchDoc): string {
        return (item.recordID + '|' + item.title);
    }

    private isItemSelected(item: Models.IEntitySearchDoc): boolean {

        var lookupKey = this.formatLookupKey(item);
        var isInList = (this.selectedItems[lookupKey] === true);

        return isInList;
    }

    private syncSelectedItemsLookupFromArray() {

        var wasUpdated: boolean = false;
        let selectedItems = this.selectedItems;
        var newSelectedItems: { [recIDTitle: string]: boolean } = _.cloneDeep(selectedItems);

        // - remove values from the lookup that aren't in the array (set value = false)

        for (var lookupKey in selectedItems) {
            if (selectedItems.hasOwnProperty(lookupKey)) {

                if (this.selectedItems[lookupKey] !== true)
                    continue;

                if (!this.isItemForKeyInArray(lookupKey, this.selectedItemsArray))
                    this.selectedItems[lookupKey] = false;
            }
        }

        // - add values to the lookup that are in the array (set value = true)

        for (var i = 0; i < this.selectedItemsArray.length; ++i) {

            var selectedItem: Models.IEntitySearchDoc = this.selectedItemsArray[i];
            var key: string = this.formatLookupKey(selectedItem);
            var shouldSet: boolean = newSelectedItems[key] !== true;

            if (shouldSet) {
                newSelectedItems[key] = true;
                wasUpdated = true;
            }
        }

        if (wasUpdated)
            this.selectedItems = newSelectedItems;

        return;
    }

    private isItemForKeyInArray(lookupKey: string, selectedItemsArray: Models.IEntitySearchDoc[]): boolean {
        return _.some(selectedItemsArray, itm => this.formatLookupKey(itm) === lookupKey);
    }

    private syncSelectedItemsArrayFromLookup() {

        //If this is a single select, just update the array and gtfo
        if (this.selectSingle) {
            this.selectedItemsArray = [];
            var itemToAdd = _.find(this.entityDocuments, entityDoc => this.formatLookupKey(entityDoc) === this.selectSingleItem);

            if (itemToAdd != null)  // make sure we found the corresponding item
            {
                this.selectedItemsArray.push(itemToAdd);
                return;
            }
            else {
                this.selectSingleItem = "";
            }
        }

        // - remove any items from the array that are not in this.selectedItems

        var newSelectedItemsArray: Models.IEntitySearchDoc[] = _.reject(this.selectedItemsArray, itm =>
            !this.isItemSelected(itm)
        );

        var wasUpdated: boolean = newSelectedItemsArray.length !== this.selectedItemsArray.length;

        // - add any values to the array from this.selectedItems, if they are not already there

        for (var lookupKey in this.selectedItems) {

            if (this.selectedItems[lookupKey] !== true)  // item is not selected, skip
                continue;

            var itemToAdd = _.find(this.entityDocuments, entityDoc => this.formatLookupKey(entityDoc) === lookupKey);
            if (itemToAdd == null)  // make sure we found the corresponding item
                continue;

            var isItemAlreadyInArray = _.some(newSelectedItemsArray, arrayItem => arrayItem.recordID === itemToAdd.recordID);
            if (!isItemAlreadyInArray) {
                newSelectedItemsArray.push(itemToAdd);
                wasUpdated = true;
            }
        }

        if (wasUpdated)
            this.selectedItemsArray = newSelectedItemsArray;

        return;
    }

    private getCharacteristicList(charTypeID: number) {
        return this.entityConfigService.getCharacteristicList(charTypeID)
            .then((res) => {
                var columns = _.sortBy(res, (chr) => {
                    return chr.label;
                }).map((chr): Models.IListTableColumn => {
                    return {
                        solrLabel: Utils.CharUtil.GetCharSolrLabel(chr.dataTypeID, chr.multipleIndicator, chr.tagLabel),
                        label: chr.label,
                        characteristicID: chr.characteristicID,
                        formatter: Utils.CharUtil.GetFormatter(chr.dataTypeID),
                        dataTypeID: chr.dataTypeID,
                        systemIndicatorID: chr.systemIndicator
                    }
                });

                this.availableColumns = columns;
            });
    }

    private setCustomColumnList(charTypeID: number, headerID: string) {
        var key = `CC-${charTypeID}-${headerID}`;
        var colList = this.cacheService.getItem(key);

        if (!colList) {
            this.getCustomListColumns()
                .then(() => {

                });
        }
    }

    private getCustomListColumns() {
        return this.accountService.getCustomColumns()
            .then((res) => {
                var dayExp = moment.duration(1, 'day');
                res.forEach((customColumns) => {
                    this.cacheService.setItem(`CC-${customColumns.charTypeID}-${customColumns.headerID}`, customColumns, dayExp);
                });
            });
    }

    GetEntityDocument(row: Models.IListTableRow) {
        return _.find(this.entityDocuments, (ed) => { return ed.recordID == row.recordID; });
    }

    AllCheckChanged() {
        _.forEach(this.entityDocuments, (itemRow) => {
            if (this.lockedRows != undefined) {
                if (!this.lockedRows[itemRow.recordID]) {
                    var lookupKey = this.formatLookupKey(itemRow);
                    this.selectedItems[lookupKey] = this.allChecked;
                }
            }
            else {
                var lookupKey = this.formatLookupKey(itemRow);
                this.selectedItems[lookupKey] = this.allChecked;
            }
        });
    }

    PageSizeChanged(pageSize: number) {
        if (this.onPageSizeChanged != null) {
            this.onPageSizeChanged({ pageSize: pageSize });
        }
    }

    PageChanged(page: number) {
        if (this.onPageChanged != null) {
            this.onPageChanged({ page: page });
        }
    }

    SortChanged(sortField: string, sortDir: number) {
        if (this.onSortChanged != null) {
            this.onSortChanged({ sortField: sortField, sortDir: sortDir });
        }
    }


    private getAssociatedFieldValues(partyIDs: string, otherCharTypeID: string, fieldLabel: string): ng.IPromise<any> {
        var recordIDs: number[] = [];
        _.forEach(this.entityDocuments,
            (e) => {
                recordIDs.push(e.recordID);
            });
        return this.entityConfigService.getAssociatedList(this.charTypeID, recordIDs.join(','), partyIDs, otherCharTypeID)
            .then((result) => {
                if (result.success) {
                    this.associatedItems = result.data;
                    let associatedItemsFiltered = _.filter(this.associatedItems, c => c.associatedCharTypeID.toString() == otherCharTypeID);
                    this.setAssociatedItems(recordIDs, _.parseInt(otherCharTypeID), associatedItemsFiltered);
                }
            });
    }



    private setAssociatedItems(recordIDs: number[], associatedCharTypeID: number, associatedItems: Models.IAssociatedItem[]) {
        if (associatedCharTypeID == Consts.CharTypeIDs.transaction) {

            _.forEach(associatedItems, (item) => {
                if (this.associatedDealTitleIDDictionary[item.associatedRecTitle] == undefined) {
                    this.associatedDealTitleIDDictionary[item.associatedRecTitle] = item.associatedRecID;
                }
            });

            for (var i = 0; i < recordIDs.length; i++) {
                let associatedItemToRecordArray = _.filter(associatedItems, c => c.recID == recordIDs[i]).map(function (elem) {
                    return elem.associatedRecTitle;
                });

                let associatedItemToRecordIDArray = _.filter(associatedItems, c => c.recID == recordIDs[i]).map(function (elem) {
                    return elem.associatedRecID;
                });

                this.associatedDealTitleDictionary[recordIDs[i]] = associatedItemToRecordArray;
                this.associatedDealRecIDDictionary[recordIDs[i]] = associatedItemToRecordIDArray;
            };

        }
        else if (associatedCharTypeID == Consts.CharTypeIDs.property) {

            _.forEach(associatedItems, (item) => {
                if (this.associatedCatalogTitleIDDictionary[item.associatedRecTitle] == undefined) {
                    this.associatedCatalogTitleIDDictionary[item.associatedRecTitle] = item.associatedRecID;
                }
            });

            for (var i = 0; i < recordIDs.length; i++) {
                let associatedItemToRecordArray = _.filter(associatedItems, c => c.recID == recordIDs[i]).map(function (elem) {
                    return elem.associatedRecTitle;
                });

                let associatedItemToRecordIDArray = _.filter(associatedItems, c => c.recID == recordIDs[i]).map(function (elem) {
                    return elem.associatedRecID;
                });

                this.associatedCatalogTitleDictionary[recordIDs[i]] = associatedItemToRecordArray;
                this.associatedCatalogRecIDDictionary[recordIDs[i]] = associatedItemToRecordIDArray;
            };

        }
    }

    private getSpecialTransactionRows(): void {
        let isSpecialColumnSelected = _.find(this.customColumns.columns, c => this.listService.isSpecialTransactionColumn(c.solrLabel));
        let isAssociatedCatalogColumnSelected = _.find(this.customColumns.columns, c => c.solrLabel == 'associated_catalog');
        this.rows = this.listService.GetRows(this.entityDocuments, this.customColumns.columns, this.availableColumns, this.lockedRows, this.allowedToDeleteRows);
        this.parties = [];
        var recordIDs: number[] = [];
        if (isSpecialColumnSelected) {
            this.getDeals(this.rows.map(row => row.recordID));
        }
        if (isAssociatedCatalogColumnSelected) {
            _.forEach(this.entityDocuments,
                (e) => {
                    recordIDs.push(e.recordID);
                });
            //dont need parties field when searching for related catalogs only
            this.getAssociatedFieldValues("", Consts.CharTypeIDs.property.toString(), "associated_catalog").finally(() => {
                this.rows = this.listService.GetRows(this.entityDocuments, this.customColumns.columns, this.availableColumns, this.lockedRows, this.allowedToDeleteRows);
            });;
        }
        this.entityConfigService.getParties().then((result) => {
            if (result) {
                if (result.success) {
                    this.parties = result.data;
                }
            }
        }).finally(() => {
            let selectedParties: IParty[] = [];
            _.forEach(this.parties, (party) => {
                _.forEach(this.customColumns.columns, (column) => {
                    if (party.partyName.toLowerCase().split(' ').join('_') == column.solrLabel) {
                        selectedParties.push(party);
                    }
                });
            });
            if (selectedParties.length > 0) {
                recordIDs = [];
                _.forEach(this.entityDocuments,
                    (e) => {
                        recordIDs.push(e.recordID);
                    });
                var partyIds = selectedParties.map(function (elem) {
                    return elem.partyID;
                }).join(",");
                //no need to search for other char types when trying to search parties
                this.entityConfigService.getAssociatedList(this.charTypeID, recordIDs.join(','), partyIds, "")
                    .then((result) => {
                        if (result.success) {
                            this.associatedItems = result.data;
                            //loop through all records                               
                            for (var i = 0; i < recordIDs.length; i++) {
                                //get parties associated to each record
                                let associatedParties = _.filter(this.associatedItems, c => c.recID == recordIDs[i]).map(function (elem) {
                                    return elem;
                                });
                                //separate parties by partyID, ie department/sales rep/etc
                                let sortedParties: { [partyGroupID: number]: string[] } = [];
                                for (var y = 0; y < associatedParties.length; y++) {
                                    if (!sortedParties[associatedParties[y].partyID]) {
                                        sortedParties[associatedParties[y].partyID] = [associatedParties[y].associatedRecTitle];
                                    }
                                    else sortedParties[associatedParties[y].partyID].push(associatedParties[y].associatedRecTitle);
                                }
                                //get entity document related to recordid
                                let doc = _.find(this.entityDocuments, e => e.recordID == recordIDs[i]);
                                //add each party to document characteristics for display
                                for (let partyID in sortedParties) {
                                    let value = sortedParties[partyID];
                                    let partyName = _.find(this.parties, p => p.partyID.toString() == partyID).partyName.toLowerCase().split(' ').join('_');
                                    doc.characteristics[partyName] = value;
                                }
                            };
                        }
                    }).finally(() => {
                        this.rows = this.listService.GetRows(this.entityDocuments, this.customColumns.columns, this.availableColumns, this.lockedRows, this.allowedToDeleteRows);
                    });
            }
        });
    }

    private getSpecialUserRows(): void {
        var isAssociatedDealColumnSelected = _.find(this.customColumns.columns, c => c.solrLabel == 'associated_deal');
        var isAssociatedCatalogColumnSelected = _.find(this.customColumns.columns, c => c.solrLabel == 'associated_catalog');
        this.associatedCatalogs = {};
        this.associatedDeals = {};
        this.associatedItems = [];
        if (!isAssociatedCatalogColumnSelected && !isAssociatedDealColumnSelected) {
            this.rows = this.listService.GetRows(this.entityDocuments, this.customColumns.columns, this.availableColumns, this.lockedRows, this.allowedToDeleteRows);
            return;
        }

        if (isAssociatedCatalogColumnSelected) {
            this.getAssociatedFieldValues("", Consts.CharTypeIDs.property.toString(), "associated_catalog").finally(() => {
                this.rows = this.listService.GetRows(this.entityDocuments, this.customColumns.columns, this.availableColumns, this.lockedRows, this.allowedToDeleteRows);
            });;
        }

        if (isAssociatedDealColumnSelected) {
            this.getAssociatedFieldValues("", Consts.CharTypeIDs.transaction.toString(), "associated_deal").finally(() => {
                this.rows = this.listService.GetRows(this.entityDocuments, this.customColumns.columns, this.availableColumns, this.lockedRows, this.allowedToDeleteRows);
            });;
        }
    }

    private getDeals(dealRecIds: number[]): ng.IPromise<any> {
        var request: Models.ISearchResultByRecordIDsRequest = {
            charTypeID: Consts.CharTypeIDs.transaction,
            recordIDs: dealRecIds.join(","),
            rowCount: dealRecIds.length
        };
        return this.entityService.getRecordDocumentsForRecordIDs(request)
            .then((result) => {
                _.forEach(result.documents, (recordDocument) => {
                    this.rightsDealsDictionary[recordDocument.recordID] = {
                        dealName: recordDocument.title,
                        primaryContactId: recordDocument.characteristics.primary_contact_id,
                        primaryContactName: recordDocument.characteristics.primary_contact
                    };
                });
            });
    }

    private getSpecialPropertyRows(): void {
        var isTopParentColumnSelected = _.find(this.customColumns.columns, c => c.solrLabel == 'top_parent');
        var isDirectParentColumnSelected = _.find(this.customColumns.columns, c => c.solrLabel == 'direct_parent');
        var isAssociatedDealColumnSelected = _.find(this.customColumns.columns, c => c.solrLabel == 'associated_deal');
        this.catalogHierarchy = [];
        this.catalogHierarchyIDTitles = {};
        this.catalogRecordHierarchy = {};
        this.catalogRecDirectParents = {};
        this.catalogRecTopMostParents = {};
        this.catalogRecHierarchyPaths = {};
        this.associatedDeals = {};
        var recordIDs: number[] = [];


        if (isAssociatedDealColumnSelected) {
            _.forEach(this.entityDocuments,
                (e) => {
                    recordIDs.push(e.recordID);
                });
            this.getAssociatedFieldValues("", Consts.CharTypeIDs.transaction.toString(), "associated_deal").finally(() => {
                this.rows = this.listService.GetRows(this.entityDocuments, this.customColumns.columns, this.availableColumns, this.lockedRows, this.allowedToDeleteRows);
            });;
        }

        if (isTopParentColumnSelected || isDirectParentColumnSelected) {
            var catalogRecordIDs: number[] = [];

            _.forEach(this.entityDocuments, (e) => {
                catalogRecordIDs.push(e.recordID);
            });

            this.entityConfigService.getCatalogHierarchy(catalogRecordIDs.join(','))
                .then((result) => {
                    if (result.success) {
                        this.catalogHierarchy = result.data;

                        _.forEach(catalogRecordIDs, (recID) => {
                            var catalogRecHierarchy = _.filter(this.catalogHierarchy, c => c.recID == recID);

                            var directParentTitles = catalogRecHierarchy.map(h => h.directParentTitle).filter(function (e, i, a) {
                                return i === a.indexOf(e);
                            });
                            this.catalogRecDirectParents[recID] = directParentTitles;

                            var topParentTitles = catalogRecHierarchy.map(h => h.topMostParentTitle).filter(function (e, i, a) {
                                return i === a.indexOf(e);
                            });
                            this.catalogRecTopMostParents[recID] = topParentTitles;

                            var hierarchyPaths = catalogRecHierarchy.map(h => h.hierarchyPath).filter(function (e, i, a) {
                                return i === a.indexOf(e);
                            });
                            this.catalogRecHierarchyPaths[recID] = hierarchyPaths.join('\n');
                        });

                        _.forEach(this.catalogHierarchy, (ch) => {
                            if (!this.catalogHierarchyIDTitles[ch.directParentTitle]) {
                                this.catalogHierarchyIDTitles[ch.directParentTitle] = ch.directParentRecID;
                            }

                            if (!this.catalogHierarchyIDTitles[ch.topMostParentTitle]) {
                                this.catalogHierarchyIDTitles[ch.topMostParentTitle] = ch.topMostParentRecID;
                            }
                        });
                    }
                }).finally(() => {
                    this.rows = this.listService.GetRows(this.entityDocuments, this.customColumns.columns, this.availableColumns, this.lockedRows, this.allowedToDeleteRows);
                });
        }
        else {
            this.rows = this.listService.GetRows(this.entityDocuments, this.customColumns.columns, this.availableColumns, this.lockedRows, this.allowedToDeleteRows);
        }
    }

    private getSpecialInventoryRows() {
        var isAssociatedCatalogColumnSelected = _.find(this.customColumns.columns, c => c.solrLabel == 'associated_catalog');

        this.associatedCatalogs = {};
        this.associatedItems = [];
        if (!isAssociatedCatalogColumnSelected) {
            this.rows = this.listService.GetRows(this.entityDocuments, this.customColumns.columns, this.availableColumns, this.lockedRows, this.allowedToDeleteRows);
            return;
        }

        if (isAssociatedCatalogColumnSelected) {
            this.getAssociatedFieldValues("", Consts.CharTypeIDs.property.toString(), "associated_catalog").finally(() => {
                this.rows = this.listService.GetRows(this.entityDocuments, this.customColumns.columns, this.availableColumns, this.lockedRows, this.allowedToDeleteRows);
            });;
        }
    }

    private getRows() {
        if (this.charTypeID == Consts.CharTypeIDs.property) {
            this.getSpecialPropertyRows();
        } else if (this.charTypeID == Consts.CharTypeIDs.transaction) {
            this.getSpecialTransactionRows();
        } else if (this.charTypeID == Consts.CharTypeIDs.user) {
            this.getSpecialUserRows();
        }
        else if (this.charTypeID == Consts.CharTypeIDs.inventory) {
            this.getSpecialInventoryRows();
        }
        else {
            this.rows = this.listService.GetRows(this.entityDocuments, this.customColumns.columns, this.availableColumns, this.lockedRows, this.allowedToDeleteRows);
        }
        this.initialized = true;
    }
}
